import client from "../../../app/core/client-http/client";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { downloadBlob } from "../../../utils/functions/downloadBlob";

export const doReportPractice = createAsyncThunk(
  "practiceManagement/get-report-practice",
  async (reportPracticeData, thunkAPI) => {
    const endpoint = "/admin/practices/exportreport";
    const response = await client.get(endpoint, null, { type: "blob" });
    downloadBlob("Report pratiche.xls", response);
  }
);

export const doReportSinglePractice = createAsyncThunk(
  "practiceManagement/get-report-single-practice",
  async (reportPracticeData, thunkAPI) => {
    const endpoint = `/admin/practices/${reportPracticeData}/exportreport`;
    const response = await client.get(endpoint, null, { type: "blob" });
    downloadBlob("Report pratica.xls", response);
  }
);

export const doReportZipPractice = createAsyncThunk(
  "practiceManagement/get-report-single-practice",
  async (reportPracticeData, thunkAPI) => {
    const endpoint = `/admin/practices/${reportPracticeData}/exportzip`;
    const response = await client.get(endpoint, null, { type: "blob" });
  }
);

export const doReportPdfPractice = createAsyncThunk(
  "practiceManagement/get-report-single-practice",
  async (reportPracticeData, thunkAPI) => {
    const endpoint = `/admin/practices/${reportPracticeData}/exportzip?singleFiles=false`;
    const response = await client.get(endpoint, null, { type: "blob" });
  }
);

// Slice Section

// initial state
const _initialState = {
  isLoading: false,
  selectedPracticesIds: [],
  tableFilters: {
    status: "",
    service: "",
    practiceName: "",
  },
};

// Slice

const practiceManagementSlice = createSlice({
  name: "practiceManagementSlice", // REDUX Storage name
  initialState: _initialState,
  reducers: {
    // il nome di questa azione dev'essere quello usato generico nella CoreTable
    setSelectTableRow: (state, action) => {
      //questo è Cosa succede nello stato specifico di questa funzionalità
      state.selectedPracticesIds = action.payload;
    },
    setTableFilters: (state, action) => {
      state.tableFilters = action.payload;
    },
  },
  // Other custom actions as needed
  extraReducers: (builder) => {
    builder
      .addCase(doReportPractice.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(doReportPractice.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(doReportPractice.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export default practiceManagementSlice;
export const { name, reducer, actions } = practiceManagementSlice;
